import { mapKeys, mapValues } from '../dependencies';
import types from './actionTypes';

const initialState = {
    data: [],
    selected: {},
    favourite: {},
    isFetching: false,
};

export default function(state = initialState, { type, payload }) {
    switch (type) {
        case types.REQUEST_RESTAURANTS:
            return {
                ...state,
                isFetching: true,
            };

        case types.REQUEST_RESTAURANTS_COMPLETED:
            return {
                ...state,
                isFetching: false,
            };

        case types.SET_RESTAURANTS:
            return {
                ...state,
                data: payload.restaurants,
            };

        case types.TOGGLE_RESTAURANT_SELECTED:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    [payload.id]: !state.selected[payload.id],
                },
            };
        case types.TOGGLE_ALL_RESTAURANTS_SELECTED:
            return {
                ...state,
                selected: mapValues(mapKeys(state.data, 'id'), () => payload.selected),
            };
        case types.TOGGLE_RESTAURANT_FAVOURITE:
            return {
                ...state,
                favourite: {
                    ...state.favourite,
                    [payload.id]: !state.favourite[payload.id],
                },
            };
        case types.SET_SELECTED:
            return {
                ...state,
                selected: payload.selected,
            };

        case types.SET_FAVOURITE:
            return {
                ...state,
                favourite: payload.favourite,
            };

        default:
            return state;
    }
}
